import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStylesV2 } from '@kubit/web-ui-product-components';
// Components
import { ButtonComponent } from '../../components/button/button.component';
// Constants
import { STYLES_NAME } from '../../constants/stylesName';
import { FOOTER_BUTTON_GHOST_PROPS } from './constants/footer.constants';
// Styles
import { FooterWrapperStyled, FooterWrapperButtonsStyled } from './footer.component.styled';
const FooterComponent = ({ mainButtonConfiguration, secondaryButtonConfiguration, buttonGhostConfiguration, variant, }) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.FOOTER_ACTION,
        variantName: variant,
    });
    return (_jsxs(FooterWrapperStyled, { styles: styles, children: [buttonGhostConfiguration ? (_jsx(ButtonComponent, { ...buttonGhostConfiguration, ...FOOTER_BUTTON_GHOST_PROPS })) : null, secondaryButtonConfiguration && mainButtonConfiguration ? (_jsxs(FooterWrapperButtonsStyled, { styles: styles, children: [_jsx(ButtonComponent, { ...secondaryButtonConfiguration }), _jsx(ButtonComponent, { ...mainButtonConfiguration })] })) : mainButtonConfiguration ? (_jsx(ButtonComponent, { ...mainButtonConfiguration })) : null] }));
};
export { FooterComponent };
//# sourceMappingURL=footer.component.js.map